import CoreComponent from '../../core/CoreComponent.vue';
import { isMobile } from '@/utils';
export default {
  extends: CoreComponent,
  mounted() {
    const cardImages = this.cmpEl.querySelectorAll('.cmp-full-width-feature__image .cmp-image__image');
    cardImages.forEach(image => {
      const card = image.closest('.cmp-full-width-feature');
      const firstCtaElement = card?.querySelector('.cmp-full-width-feature__button .cmp-button');
      if (firstCtaElement && !isMobile()) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', () => {
          firstCtaElement.click();
        });
      }
    });
  }
};